import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { tap, map } from 'rxjs/operators';
import { of, Observable, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService extends ApiService {
  configurationCache: Record<string, string> = {};

  constructor(public http: HttpClient) {
    super(http);
  }

  preloadConfig() {
    forkJoin([
      this.cacheByKey('SensorTeaserImageCount'),
      this.cacheByKey('SensorTeaserHeader'),
      this.cacheByKey('SensorTeaserDetail'),
      this.cacheByKey('SensorTeaserAssets'),
      this.cacheByKey('SensorTeaserEmailBtnText'),
    ]).subscribe();
  }

  getByKey(key: string): Observable<Config> {
    return this.http.get<Config>(this.endpoint('api', 'config', 'key', key));
  }

  getPortalSettings(): Observable<any> {
    return this.http.get<any>('portalsettings');
  }

  cacheByKey(key: string) {
    return this.getByKey(key).pipe(
      map((val: any) => val.configValue),
      tap((val: any) => (this.configurationCache[key] = val)),
    );
  }

  purgeByKey(key: string) {
    delete this.configurationCache[key];
  }

  fromCache(key: string) {
    return this.configurationCache[key] ? of(this.configurationCache[key]) : this.cacheByKey(key);
  }

  updateConfiguration(configuration: any) {
    return this.http.put<Config>(this.endpoint('api', 'config', `${configuration.id}`), configuration);
  }
}

export interface Config {
  guid: string;
  configKey: string;
  configValue: string;
}
